import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api, { formatRp } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import GlassCard from "@/components/GlassCard";
import MidtransModal from "@/components/MidtransModal";
import { Button } from "@/components/ui/button";
import { Receipt, Wallet } from "lucide-react";

const STATUS_COLOR = {
  paid: "text-emerald-400 bg-emerald-500/10",
  pending: "text-amber-400 bg-amber-500/10",
  unpaid: "text-slate-400 bg-slate-500/10",
  expire: "text-rose-400 bg-rose-500/10",
  cancel: "text-rose-400 bg-rose-500/10",
};

export default function Billing() {
  const { refresh } = useAuth();
  const [topupOpen, setTopupOpen] = useState(false);
  const invoices = useQuery({ queryKey: ["invoices"], queryFn: async () => (await api.get("/invoices")).data });

  return (
    <div className="space-y-6" data-testid="billing-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-4xl font-extrabold text-white">Billing</h1>
          <p className="text-slate-400 mt-1">Riwayat transaksi & top up saldo.</p>
        </div>
        <Button onClick={() => setTopupOpen(true)} className="btn-cyan text-white border-0" data-testid="billing-topup-btn">
          <Wallet size={16} className="mr-2" /> Top Up
        </Button>
      </div>

      <GlassCard className="p-0 overflow-hidden">
        <div className="px-6 py-4 border-b border-slate-800 flex items-center gap-2">
          <Receipt size={18} className="text-cyan-400" />
          <h2 className="font-heading font-bold text-white">Riwayat Transaksi</h2>
        </div>
        {invoices.data?.length ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-slate-500 border-b border-slate-800">
                  <th className="px-6 py-3 font-medium">Invoice</th>
                  <th className="px-6 py-3 font-medium">Tanggal</th>
                  <th className="px-6 py-3 font-medium">Nominal</th>
                  <th className="px-6 py-3 font-medium">Status</th>
                </tr>
              </thead>
              <tbody>
                {invoices.data.map((o) => (
                  <tr key={o.id} className="border-b border-slate-800/50 hover:bg-slate-800/20" data-testid={`invoice-${o.id}`}>
                    <td className="px-6 py-3 font-mono text-xs text-cyan-300">{o.id}</td>
                    <td className="px-6 py-3 text-slate-400">{new Date(o.created_at).toLocaleDateString("id-ID")}</td>
                    <td className="px-6 py-3 text-white font-semibold">{formatRp(o.total_idr)}</td>
                    <td className="px-6 py-3"><span className={`text-xs font-medium px-2.5 py-1 rounded-full ${STATUS_COLOR[o.status] || STATUS_COLOR.unpaid}`}>{o.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="p-10 text-center text-slate-400" data-testid="no-invoices">
            <Receipt className="mx-auto text-slate-600 mb-3" size={36} />
            Belum ada transaksi.
          </div>
        )}
      </GlassCard>

      <MidtransModal open={topupOpen} onOpenChange={setTopupOpen} onPaid={() => { refresh(); invoices.refetch(); }} />
    </div>
  );
}
